import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMyApplications } from '@/modules/candidate/api/application.api';

export const fetchMyApplicationsThunk = createAsyncThunk(
  'myApplications/fetch',
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await getMyApplications();
      return response.data.applications || [];
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch applications.'
      );
    }
  }
);